import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import Header from "@components/Header/Header";
import PulseEntry from "@features/pulse/components/PulseEntry/PulseEntry";
import FeaturedVideoPlaylistProps from "@routes/Videos/VideosPage/components/FeaturedVideoPlaylist/FeaturedVideoPlaylist";

import MoreVideos from "./components/MoreVideos";
import { VideosPageData } from "./utils/types";

/** This is the component for displaying the videos page content. */
const VideosPageContent = ({
  videos,
  seoFooterData,
  featuredVideos,
}: VideosPageData): React.ReactElement => {
  return (
    <div className="w-full" data-testid="videos-page-content-component">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <PulseEntry />

      <Container rootClassName="w-full">
        <h1 className="border-b border-gray-850 pb-3 pt-6 font-playfair text-8xl uppercase">
          Videos
        </h1>
      </Container>

      <Container rootClassName="pt-6">
        <div className="mb-10 grid grid-cols-1 lg:grid-cols-3">
          <div className="col-span-1 lg:col-span-2">
            <BlockTitle text="FEATURED VIDEOS" rootClassName="mb-3" />

            <FeaturedVideoPlaylistProps videos={featuredVideos} />
          </div>

          <div className="col-span-1 lg:col-span-1">
            <Ad
              adType="imu2"
              className="flex flex-col items-center justify-center lg:sticky lg:top-[70px]"
            />
          </div>
        </div>

        <MoreVideos videos={videos} className="mb-6" />
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default VideosPageContent;
